// userUtils.js
import { supabase } from '../supabaseClient';

// 유저 데이터 가져오기 (Edge Function 사용 - 보안 강화)
export const fetchUserByWallet = async () => {
  const { data: { session } } = await supabase.auth.getSession();
  
  if (!session?.access_token) {
    return null;
  }
  
  const response = await supabase.functions.invoke('get-user-data', {
    headers: {
      Authorization: `Bearer ${session.access_token}`
    }
  });
  
  if (response.error) {
    console.error('fetchUserByWallet error:', response.error);
    return null;
  }
  
  return response.data;
};

// 유저 생성/업데이트 (Edge Function 사용)
export const upsertUser = async (walletAddress) => {
  const { data: { session } } = await supabase.auth.getSession();
  
  if (!session?.access_token) {
    throw new Error('No access token');
  }
  
  const response = await supabase.functions.invoke('upsert-user', {
    body: { address: walletAddress },
    headers: {
      Authorization: `Bearer ${session.access_token}`
    }
  });
  
  if (response.error) {
    throw new Error(response.error.message || 'Upsert failed');
  }
  
  return response.data;
};

// Context 상태 초기화 헬퍼
export const clearUserState = (setWalletAddress, setCurrentPoints, setNickname, setDustPoints) => {
  setWalletAddress(null);
  setCurrentPoints(0);
  setNickname('');
  setDustPoints(0);
};
